import FormInternalDimensions from './FormInternalDimension';

export default FormInternalDimensions;
